import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => { if (user && user !== false) nav("/admin"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <main data-testid="page-login" className="min-h-screen pt-32 pb-32 flex items-center bg-[#FAFAF9]">
      <div className="max-w-md mx-auto px-6 w-full">
        <div className="flex items-center gap-3 text-[#A5854C] mb-6">
          <div className="hairline w-12"></div>
          <span className="font-mono text-[11px] uppercase tracking-[0.35em]">Admin · Sign in</span>
        </div>
        <h1 className="font-serif font-light text-[#0E1B2E] text-[40px] leading-tight tracking-tight">Administrator access.</h1>
        <form onSubmit={submit} className="mt-10 border border-[#0E1B2E]/10 bg-white p-8 space-y-6">
          <label className="block">
            <span className="block font-mono text-[10px] uppercase tracking-[0.28em] text-[#9AA3AE] mb-2">Email</span>
            <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-transparent border-b border-[#0E1B2E]/15 focus:border-[#A5854C] py-3 text-[#0E1B2E] outline-none" />
          </label>
          <label className="block">
            <span className="block font-mono text-[10px] uppercase tracking-[0.28em] text-[#9AA3AE] mb-2">Password</span>
            <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-transparent border-b border-[#0E1B2E]/15 focus:border-[#A5854C] py-3 text-[#0E1B2E] outline-none" />
          </label>
          <button data-testid="login-submit" disabled={loading} className="btn-gold w-full py-3 text-[11px] uppercase tracking-[0.25em] font-mono">{loading ? "Signing in…" : "Sign in"}</button>
        </form>
      </div>
    </main>
  );
}
